import {
  ChevronUpIcon,
  ArrowRightStartOnRectangleIcon,
} from "@heroicons/react/24/outline";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownLabel,
  DropdownMenu,
} from "../catalyst/dropdown";
import { NavbarItem, NavbarLabel } from "../catalyst/navbar";
import useAuthStore from "../../store/authStore";
import { UserNameDisplay } from "../UserNameDisplay";
import Avatar from "../Avatar";

export const CurrentUserLogout: React.FC = () => {
  const { currentUser, logout } = useAuthStore();

  return (
    <Dropdown>
      <DropdownButton as={NavbarItem} type="button" data-testid="logout-option">
        <Avatar
          firstName={currentUser?.firstName??""}
          lastName={currentUser?.lastName??""}
          imageUrl={`/api/static/images/${currentUser?.profilePicture}`}
          className="w-8 h-8"
        />
        <NavbarLabel>
        <div className="usernameContainer">
          {currentUser && <UserNameDisplay user={currentUser} />}
          </div>
        </NavbarLabel>
        <ChevronUpIcon />
      </DropdownButton>
      <DropdownMenu className="min-w-64 z-50 cursor-pointer" anchor="top start">
        <DropdownItem
          onClick={() => logout()}
          type="button"
          data-testid="logout"
          className="cursor-pointer"
        >
          <ArrowRightStartOnRectangleIcon className="w-12 h-12" />
          <DropdownLabel>Logout</DropdownLabel>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};
